import { useState, useEffect } from "react";

export function useLocalStorage(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // localStorage pieno o disabilitato
    }
  }, [key, value]);

  return [value, setValue];
}

export function clearProgress() {
  const keys = [
    "cvcraft_info",
    "cvcraft_esp",
    "cvcraft_form",
    "cvcraft_comp",
    "cvcraft_tpl",
    "cvcraft_step",
    "cvcraft_ai",
    "cvcraft_cl",
  ];
  keys.forEach((k) => localStorage.removeItem(k));
}
